import { BeforeAfterSlider } from "@/components/BeforeAfterSlider";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useState, useEffect } from "react";
import { EstimateFlow } from "@/components/EstimateFlow";
export const projects = [
  {
    beforeImage:
      "https://vibe.filesafe.space/1781836485235618884/attachments/d7d61ef5-f962-46bd-aa0d-2c452ed33d6e.webp",
    afterImage:
      "https://vibe.filesafe.space/1781836485235618884/attachments/a31fc2b7-d7ab-4836-be3c-b77e3c55ed16.webp",
    title: "Tree Removal",
    location: "Raleigh, NC",
    date: "January 2026",
  },
  {
    beforeImage:
      "https://vibe.filesafe.space/1781836485235618884/attachments/9086fef5-5b9e-464e-9c51-368e645ca978.webp",
    afterImage:
      "https://vibe.filesafe.space/1781836485235618884/attachments/a0d78af5-d3a7-4554-8c0b-f763c0c6fc20.webp",
    title: "Roof Replacement",
    location: "Greensboro, NC",
    date: "January 2026",
  },
  {
    beforeImage:
      "https://vibe.filesafe.space/1781836485235618884/attachments/e10606a8-aa82-4d47-8b9c-058e4985b0a5.jpg",
    afterImage:
      "https://vibe.filesafe.space/1781836485235618884/attachments/0ea35039-8c4c-4b47-81b0-d32fe54ed4bd.jpg",
    title: "Porch/deck additions & renovations",
    location: "Raleigh, NC",
    date: "June 2026",
  },

  {
    image:
      "https://vibe.filesafe.space/1781836485235618884/attachments/4a4c16ca-6f4c-4218-ab9d-730af96214e2.webp",
    title: "Screened-in porch construction",
    location: "Raleigh, NC",
    date: "June 2026",
  },
  {
    beforeImage:
      "https://vibe.filesafe.space/1781836485235618884/attachments/4e8fd900-9b54-47ce-bb10-61b02205413e.webp",
    afterImage:
      "https://vibe.filesafe.space/1781836485235618884/attachments/21186714-760b-49ab-b045-f98ca3be3e18.webp",
    title: "Deck & stair building",
    location: "Cary, NC",
    date: "July 2026",
  },
  {
    beforeImage:
      "https://vibe.filesafe.space/1781836485235618884/attachments/56147b73-0286-4c7a-ba14-ba0072edbc29.webp",
    afterImage:
      "https://vibe.filesafe.space/1781836485235618884/attachments/99d992a7-8097-4220-9e8f-48a14882f5b3.webp",
    title: "Roof & Gutter Cleaning",
    location: "Wake Forest, NC",
    date: "July 2026",
  },
  {
    beforeImage:
      "https://vibe.filesafe.space/1781836485235618884/attachments/ffcf7a1a-71c9-41d5-a264-aad17915e57c.jpg",
    afterImage:
      "https://vibe.filesafe.space/1781836485235618884/attachments/45637f9a-bcbe-478c-a151-e9c6ead7acee.jpg",
    title: "Gutter Cleaning",
    location: "Knightdale, NC",
    date: "July 2026",
  },
  {
    beforeImage:
      "https://vibe.filesafe.space/1781836485235618884/attachments/25811c9e-a1e3-4bce-925f-370baf9fd7f2.png",
    afterImage:
      "https://vibe.filesafe.space/1781836485235618884/attachments/5499d073-627d-4baa-884d-3c17cd118b5d.png",
    title: "Wood Rot Repair",
    location: "Wake Forest, NC",
    date: "August 2026",
  },
];

export default function GalleryPage() {
  const [isEstimateOpen, setIsEstimateOpen] = useState(false);

  useEffect(() => {
    const handleOpenEstimate = () => setIsEstimateOpen(true);
    document.addEventListener("open-estimate", handleOpenEstimate);
    return () =>
      document.removeEventListener("open-estimate", handleOpenEstimate);
  }, []);

  useEffect(() => {
    document.title =
      "See Our Transformations | Get Inspired & Get a Free Quote | Long Vista";
  }, []);
  return (
    <div className="flex flex-col min-h-screen bg-white">
      {/* Header */}
      <section className="pt-0 pb-2 border-b border-gray-100">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-0">
            Our Portfolio
          </h1>
          <p className="text-base md:text-lg text-gray-700 max-w-2xl mx-auto">
            Browse our gallery of recent transformations. Drag the sliders to
            see the before and after of each project.
          </p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="pt-1 pb-4 md:pt-2 md:pb-8">
        <div className="container mx-auto px-2 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 lg:grid-cols-2 gap-2 sm:gap-8 gap-y-6 sm:gap-y-12">
            {projects.map((project, idx) =>
              "image" in project ? (
                <div key={idx} className="group cursor-pointer">
                  <div className="relative w-full aspect-square overflow-hidden">
                    <img
                      src={project.image}
                      alt={project.title}
                      className="w-full h-full object-cover"
                      loading="lazy"
                      decoding="async"
                      width="800"
                      height="800"
                    />
                  </div>
                  <div className="text-left pt-2">
                    <h3 className="font-bold text-gray-900 text-sm sm:text-lg mb-0.5 sm:mb-1 truncate">
                      {project.title}
                    </h3>
                    <p className="text-xs sm:text-sm text-gray-600 truncate">
                      {project.location}
                    </p>
                    <p className="text-xs sm:text-sm text-gray-500 mt-0.5">
                      {project.date}
                    </p>
                  </div>
                </div>
              ) : (
                <BeforeAfterSlider
                  key={idx}
                  beforeImage={(project as any).beforeImage}
                  afterImage={(project as any).afterImage}
                  title={project.title}
                  location={project.location}
                  date={project.date}
                />
              ),
            )}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 border-t border-gray-100">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Ready for your own transformation?
          </h2>
          <p className="text-gray-700 mb-8 max-w-xl mx-auto">
            Contact us today to get started with a free, no-obligation estimate
            for your next remodeling or roofing project.
          </p>
          <Button
            onClick={() => setIsEstimateOpen(true)}
            className="bg-primary hover:bg-primary/90 text-white font-bold px-8 py-6 rounded-lg text-lg"
          >
            Get a Free Estimate <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
        </div>
      </section>

      <EstimateFlow isOpen={isEstimateOpen} onOpenChange={setIsEstimateOpen} />
    </div>
  );
}
